<template>
  <div class="view">
    <!-- <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }">Home</v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
        User
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'userView', params: {} }">
        View User
      </v-breadcrumbs-item>
    </v-breadcrumbs> -->

    <v-card v-if="loaded" elevation="0">
      <v-card-title>
        View User
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-if="user.firstName">
                <td max-width="35%" class="text-subtitle-1">First Name:</td>
                <td>{{ user.firstName }}</td>
              </tr>

              <tr v-if="user.lastName">
                <td max-width="35%" class="text-subtitle-1">Last Name:</td>
                <td>{{ user.lastName }}</td>
              </tr>

              <tr v-if="user.username">
                <td max-width="35%" class="text-subtitle-1">User Name:</td>
                <td>{{ user.username }}</td>
              </tr>

              <tr v-if="user.phone">
                <td max-width="35%" class="text-subtitle-1">Phone:</td>
                <td>{{ user.phone }}</td>
              </tr>

              <tr v-if="user.email">
                <td max-width="35%" class="text-subtitle-1">Email:</td>
                <td>{{ user.email }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-btn
          text
          class="text-capitalize"
          color="blue"
          @click="openResetPasswordDialog = true"
          >Reset password</v-btn
        >
      </v-card-text>
    </v-card>

    <v-sheet class="d-md-flex pa-6 pt-0">
      <v-sheet class="flex-column"></v-sheet>

      <v-spacer></v-spacer>

      <v-sheet class="justify-right text-right">
        <v-btn @click="goBack" plain class="mr-4">Back</v-btn>

        <v-btn @click="onEditDialog" color="primary" rounded x-large
          >Edit</v-btn
        >
      </v-sheet>
    </v-sheet>

    <v-row justify="center">
      <v-dialog v-model="openResetPasswordDialog" max-width="400px" scrollable>
        <v-card>
          <UserPasswordResetForm
            :key="userId"
            :id="userId"
            :firstName="user.firstName"
            :lastName="user.lastName"
            @close="openResetPasswordDialog = false"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { getUser } from "@/services/user";
import { mapActions } from "vuex";
const UserPasswordResetForm = () =>
  import("@/components/user/UserPasswordResetForm.vue");

export default {
  name: "ViewUser",
  props: ["userId", "isModal"],
  components: {
    UserPasswordResetForm,
  },
  data() {
    return {
      id: "",
      user: {},
      loaded: false,
      relations: {},
      openResetPasswordDialog: false,
    };
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    goBack() {
      if (this.isModal) {
        this.onCloseDialog();
      } else {
        this.$router.go(-1);
      }
    },
    setInstace() {
      this.setDependencies().then(() => {
        if (this.id) {
          getUser(this.id)
            .then(response => {
              this.user = response.data;
              this.loaded = true;
            })
            .catch(() => {
              this.addErrorMessage("Error loading user");
              this.loaded = true;
            });
        }
      });
    },
    async setDependencies() {
      return null;
    },
    getRelationText(id, relationProperty, relationAttribute) {
      const relationList = this.relations[relationProperty];
      if (relationList) {
        const relationObj = relationList.find(r => r.id == id);
        return relationObj[relationAttribute];
      } else {
        return "";
      }
    },
    onCloseDialog() {
      this.id = null;
      this.$emit("closeUserDialog");
    },
    onEditDialog() {
      this.$emit("editUserDialog");
    },
  },
  created() {
    this.id = this.userId;
    this.setInstace();
    this.$emit("showParent", false);
  },
};
</script>
